import Clarity from "@microsoft/clarity";

let isInitialized = false;

export function initializeClarity() {
  const projectId = process.env.CLARITY_PROJECT_ID;

  if (!projectId || isInitialized) {
    return;
  }

  Clarity.init(projectId);
}

export function setupIdentity({
  customId,
  customSessionId,
  customPageId,
  friendlyName
}) {
  if (!isInitialized || !customId) return;

  Clarity.identify(customId, customSessionId, customPageId, friendlyName);
}
